import React, { useRef } from 'react';
import vid from './km_20241229_720p_60f_20241229_113521.mp4'; 
import './typingadd.css';
import { useNavigate } from 'react-router-dom';
export default function Typingadd() {
  const videoRef = useRef(null);

  const handleLoadedData = () => {
    if (videoRef.current) {
      videoRef.current.play(); 
    }
  };
  const navigate=useNavigate();
const handleadd =()=>{
    navigate(`/typingtest`)
}

  return (
    <>
      <section id="typingadd-section">
        <div id="typingadd-cont" onClick={handleadd}>
          <h3>
            Want to Test Your Typing Skills For <span title='Click Now' >FREE</span>
          </h3>
          <video
            ref={videoRef}
            src={vid}
            width="260px"
            height="150px"
            loop
            autoPlay
            muted
            onLoadedData={handleLoadedData} 
          ></video>
          <h4>Participate and know your accuracy and <span>WPM</span>(Word Per Minute)</h4>
        </div>
      </section>
    </>
  );
}
